import { ContactDialog } from '@/components/marketing/contact-dialog';
import { Button } from '@/components/ui/button';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/faq')({
    component: FaqPage,
});

function FaqPage() {
    return (
        <div className="min-h-screen bg-emerald-50 text-emerald-950">
            <header className="border-b border-emerald-100 bg-white/80">
                <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5">
                    <Link to="/" className="flex items-center gap-3">
                        <img
                            src="https://res.cloudinary.com/flannery38/image/upload/v1771973120/stockwright/logo.svg"
                            alt="Stockwright"
                            className="h-6"
                        />
                    </Link>
                    <div className="flex items-center gap-3">
                        <Link
                            to="/security"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            Security
                        </Link>
                        <Link
                            to="/terms"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            Terms
                        </Link>
                        <Button asChild className="bg-emerald-700 text-white">
                            <Link to="/auth" search={{ mode: 'signup' }}>
                                Start Free Trial
                            </Link>
                        </Button>
                    </div>
                </div>
            </header>

            <main className="mx-auto w-full max-w-5xl px-4 py-12">
                <div className="mb-10">
                    <p className="text-xs font-semibold uppercase tracking-wide text-emerald-600/80">
                        FAQ
                    </p>
                    <h1 className="mt-2 text-3xl font-semibold">
                        Frequently asked questions
                    </h1>
                    <p className="mt-3 max-w-2xl text-sm text-emerald-900/70">
                        Everything you need to know before starting your free
                        trial.
                    </p>
                </div>

                <div className="grid gap-6">
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Do I need a credit card for the free trial?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            We require a card to start the standard trial. If
                            you have a promo code for free access, no card is
                            required.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Can I cancel anytime?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Yes. You can cancel from your account billing page
                            at any time. Your access stays active until the
                            end of your billing period.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            What happens if my payment fails?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Stripe will retry payments and notify you. If the
                            payment remains unpaid, your subscription may pause
                            until billing is resolved.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            How do I apply a promo code?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Enter your promo code on the subscribe page before
                            you’re redirected to Stripe. You’ll see the code
                            applied on the Stripe checkout page.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Where can I get help?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Use the contact form on the site, and we’ll get back
                            to you quickly.
                        </p>
                        <div className="mt-4">
                            <ContactDialog />
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}
